import React from 'react'

import { Colored } from '../..'
import ActionLink from '../Estate/Store/ActionLink'
import { ActionGroup } from './ActionLogs.styles'

const tableDisplay = ({ calculateStatusColor, calculateMethodColor, onChangeSelected, t }) => {
    const elements = [
        {
            onlyOnMobile: true,
            field: 'name',
            label: t('Name'),
            props: { align: 'left' },
            transform: null,
            width: '100px',
        },
        {
            onlyOnMobile: true,
            field: 'url',
            label: t('URL'),
            props: { align: 'left' },
            transform: null,
            width: '180px',
        },
        {
            onlyOnMobile: true,
            field: 'created_at',
            label: t('Date'),
            props: { align: 'center' },
            transform: null,
            width: '140px',
        },
        {
            onlyOnMobile: true,
            field: 'id',
            key: 'actions',
            label: '',
            width: null,
            props: { align: 'right' },
            transform: (id) => (
                <ActionGroup>
                    <ActionLink
                        onClick={(e) => {
                            e.preventDefault()
                            if (id) onChangeSelected(id)
                        }}
                        width="100%"
                    >
                        {t('View')}
                    </ActionLink>
                </ActionGroup>
            ),
        },
        {
            field: 'name',
            label: t('Name'),
            props: null,
            transform: null,
            width: '100px',
        },
        {
            field: 'method',
            label: t('Method'),
            props: { align: 'left' },
            transform: (method) => (calculateMethodColor ? <Colored color={calculateMethodColor(method)}>{method}</Colored> : method),
            width: '90px',
        },
        {
            field: 'url',
            label: t('URL'),
            props: { align: 'left' },
            transform: null,
            width: '450px',
        },
        {
            field: 'response_status',
            label: t('Response code'),
            props: { align: 'center' },
            transform: (status) =>
                calculateStatusColor ? (
                    <>
                        {calculateStatusColor(status)}
                        {status}
                    </>
                ) : (
                    status
                ),
            width: '140px',
        },
        {
            field: 'created_at',
            label: t('Date'),
            props: { align: 'center' },
            transform: null,
            width: '180px',
        },
        {
            field: 'id',
            key: 'actions',
            label: '',
            width: null,
            props: { align: 'right' },
            transform: (id) => (
                <ActionGroup>
                    <ActionLink
                        onClick={(e) => {
                            e.preventDefault()
                            if (id) onChangeSelected(id)
                        }}
                        width="100%"
                    >
                        {t('View')}
                    </ActionLink>
                </ActionGroup>
            ),
        },
    ]

    return elements
}

export default tableDisplay
